import { ReactNode, RefObject } from "react";
import {
  useForm,
  UseFormReturn,
  FieldValues,
  Resolver,
  DefaultValues,
  SubmitHandler,
} from "react-hook-form";

interface FormProps<FormValues extends FieldValues> {
  children: (methods: UseFormReturn<FormValues>) => ReactNode;
  onSubmit: SubmitHandler<FormValues>;
  defaultValues?: DefaultValues<FormValues>;
  resolver: Resolver<FormValues>;
  formId?: string;
  formRef?: RefObject<HTMLFormElement>;
}

export default function Form<FormValues extends FieldValues>({
  defaultValues,
  children,
  onSubmit,
  resolver,
  formId = "hook-form",
  formRef,
}: FormProps<FormValues>) {
  const methods = useForm<FormValues>({ defaultValues, resolver });
  const { handleSubmit } = methods;

  return (
    <form id={formId} ref={formRef} onSubmit={handleSubmit(onSubmit)}>
      {children(methods)}
    </form>
  );
}
